var map = {
	"./arrow-up-thin.svg": 1632,
	"./back.svg": 9082,
	"./basket-black.svg": 3819,
	"./basket.svg": 8989,
	"./cart.svg": 6849,
	"./check-decagram.svg": 1270,
	"./close.svg": 5837,
	"./cn-flag.svg": 1979,
	"./continue-drugs/afternoon-active.svg": 9426,
	"./continue-drugs/afternoon.svg": 827,
	"./continue-drugs/all-active.svg": 8601,
	"./continue-drugs/all.svg": 9818,
	"./continue-drugs/evening-active.svg": 466,
	"./continue-drugs/evening.svg": 3547,
	"./continue-drugs/morning-active.svg": 6241,
	"./continue-drugs/morning.svg": 9679,
	"./continue-drugs/night-active.svg": 4943,
	"./continue-drugs/night.svg": 7697,
	"./down-black.svg": 7077,
	"./down.svg": 667,
	"./en-flag.svg": 4729,
	"./facebook.svg": 3479,
	"./favorite.svg": 5547,
	"./filter-black.svg": 1711,
	"./filter.svg": 7985,
	"./grey-forward.svg": 302,
	"./info.svg": 6947,
	"./jp-flag.svg": 1252,
	"./km-flag.svg": 7314,
	"./like-active.svg": 9989,
	"./like.svg": 5998,
	"./line-black.svg": 5860,
	"./line.svg": 8361,
	"./link.svg": 1119,
	"./m-coin.svg": 7866,
	"./main-filter.svg": 351,
	"./menu/cart-active.svg": 3734,
	"./menu/cart.svg": 3159,
	"./menu/home-active.svg": 7467,
	"./menu/home.svg": 7864,
	"./menu/my-drugs-active.svg": 516,
	"./menu/my-drugs.svg": 5673,
	"./menu/profile-active.svg": 3727,
	"./menu/profile.svg": 3780,
	"./mini-white-line.svg": 5309,
	"./money.svg": 8030,
	"./my-drugs-black.svg": 2577,
	"./my-drugs.svg": 1703,
	"./next.svg": 2396,
	"./order-statuses/cancelled.svg": 6532,
	"./order-statuses/delivered-active.svg": 3000,
	"./order-statuses/delivered.svg": 7957,
	"./order-statuses/paid-active.svg": 4208,
	"./order-statuses/paid-cancelled.svg": 5323,
	"./order-statuses/paid.svg": 1677,
	"./order-statuses/shipping-active.svg": 6820,
	"./order-statuses/shipping.svg": 3913,
	"./pin.svg": 2528,
	"./play.svg": 3138,
	"./plus.svg": 4491,
	"./primary-add.svg": 1161,
	"./primary-back.svg": 2865,
	"./primary-basket.svg": 5598,
	"./remove.svg": 2315,
	"./search.svg": 4343,
	"./share.svg": 7300,
	"./small-check.svg": 3339,
	"./th-flag.svg": 6374,
	"./tiktok.svg": 5301,
	"./trash.svg": 6891,
	"./white-info.svg": 5543,
	"./white-line.svg": 2269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;